"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableBody = void 0;
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
function TableBody({ children, testId, className }) {
    return (react_1.default.createElement("tbody", { className: (0, clsx_1.default)('divide-y divide-borderColor bg-transparent', className), "data-testid": testId }, children));
}
exports.TableBody = TableBody;
//# sourceMappingURL=TableBody.js.map